import { Injectable } from '@angular/core';
import { Client, Message, StompSubscription } from '@stomp/stompjs';
import { from, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StompConectionService {

  private client: Client;
  private subscriptions: StompSubscription[] = []; // Registro interno de suscripciones

  private previousSubscriptions: Map<string, Subject<Message>> = new Map();

  constructor() {
    this.client = new Client({
      brokerURL: environment.stompSocketUrl,
      reconnectDelay: 5000, // Añadir un retraso de reconexión
      heartbeatIncoming: 20000,
      heartbeatOutgoing: 20000
    });

    this.client.onConnect = () => {
      this.resubscribeToPreviousDestinations();
      console.log('STOMP connected');
    };

    this.client.onDisconnect = () => {
      console.log('STOMP disconnected');
    };

    this.client.onStompError = (frame) => {
      console.error('STOMP error', frame);
    };
  }
  // connect() {
  //   this.client.brokerURL = environment.stompSocketUrl;
  //   this.client.activate();
  // }


  connect(): Observable<void> {
    return from(new Promise<void>((resolve, reject) => {
      this.client.onConnect = () => {
        resolve();
        this.resubscribeToPreviousDestinations();
        console.log('STOMP connected');
      };

      this.client.onStompError = (error) => {
        reject(new Error('Error al conectar al servidor STOMP'));
      };

      this.client.activate();
    }));
  }

  private resubscribeToPreviousDestinations(): void {
    this.previousSubscriptions.forEach((subject, destination) => {
      this.subscribeToDestination(destination, subject);
    });
  }

  private subscribeToDestination(destination: string, subject: Subject<Message>): void {
    const subscription = this.client.subscribe(destination, message => {
      subject.next(message);
    });
    this.subscriptions.push(subscription);
  }

  subscribeStomp(destination: string): Observable<Message> {
    let subject = this.previousSubscriptions.get(destination);

    if (!subject) {
      subject = new Subject<Message>();
      this.previousSubscriptions.set(destination, subject);
      this.subscribeToDestination(destination, subject);
      this.subscriptions.push();
    }

    return subject.asObservable();
  }

  sendMessage(destination: string, body: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        if (this.client && this.client.connected) {
            this.client.publish({ destination, body: JSON.stringify(body) });
            resolve();
        } else {
            console.error('STOMP Connection is not established :(.');
            reject(new Error('STOMP Connection is not established'));
        }
    });
}

  disconnect(): void {
    // Desuscribirse de todas las suscripciones en el registro interno
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    // Limpiar el registro interno
    this.subscriptions = [];
    // Desconectar el cliente STOMP
    if (this.client && this.client.connected) {
      this.client.deactivate();
    }
  }
}